import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="text-2xl font-fun text-primary-400">91</span>
              <span className="text-lg font-heading font-bold text-white">次元</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              专为二次元爱好者打造的内容聚合平台，汇聚动漫、漫画、轻小说、Cosplay等多元次元文化。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">内容分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快捷链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
              <li><a href="#contact" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a></li>
              <li><a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关注我们</h4>
            <div className="flex items-center gap-3 mb-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line text-background-200"></i>
              </a>
            </div>
            <p className="text-sm text-background-300">
              联系邮箱：contact@91acgn.com
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 91次元 - 二次元爱好者的次元聚集地。保留所有权利。
          </p>
          <p className="text-xs text-background-400">
            在91次元，开启你的次元之旅。
          </p>
        </div>
      </div>
    </footer>
  );
}